import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import { useStableId } from "../../helper/hooks/useStableId.js";
import { getVariantClasses } from "../variantProvider/functions/getVariantClasses.js";
import styles from "./Tile.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Tile = /*#__PURE__*/forwardRef(({
  id,
  icon,
  checked = false,
  input: Input,
  alwaysShowOutline,
  onClick,
  onChange,
  value,
  label,
  reversed,
  variant,
  alignment = 'HORIZONTAL',
  error,
  disabled
}, ref) => {
  const tileId = useStableId(id);
  return /*#__PURE__*/_jsxs("label", {
    ref: ref,
    className: classNames(styles.tile, {
      [styles.reversed]: reversed,
      [styles.alwaysShowOutline]: alwaysShowOutline,
      [styles.checked]: checked,
      [styles.vertical]: alignment === 'VERTICAL',
      [styles.error]: error,
      [styles.disabled]: disabled
    }, getVariantClasses(variant, false, !!disabled)),
    htmlFor: tileId,
    children: [/*#__PURE__*/_jsxs("span", {
      className: styles.label,
      children: [!!icon && /*#__PURE__*/_jsx("span", {
        className: styles.icon,
        children: /*#__PURE__*/_jsx(IconRenderer, {
          icon: icon,
          size: 48
        })
      }), label]
    }), /*#__PURE__*/_jsx("span", {
      className: styles.input,
      children: /*#__PURE__*/_jsx(Input, {
        checked: checked,
        onClick: onClick,
        onChange: onChange,
        id: tileId,
        variant: variant,
        value: value,
        error: !!error,
        disabled: disabled
      })
    })]
  });
});